import { PageFilter } from '../state/app';
import { ProductType, ProductTypeListFilter } from '../state/productType';
import axios from '../utils/axios';

const baseUrl = `/api/productTypes`;

export const fetchProductTypeList = async ({
  filters,
  paging,
}: {
  filters: ProductTypeListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const fetchProductType = async (id: ProductType['id']) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.get(requestUrl);
};

export const createProductType = async (productType: ProductType) => {
  const requestUrl = `${baseUrl}`;
  return await axios.post(requestUrl, productType);
};

export const updateProductType = async (productType: ProductType) => {
  const requestUrl = `${baseUrl}`;
  return await axios.put(requestUrl, productType);
};
